var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-select',{attrs:{"name":_vm.name,"label":"value","value":_vm.parameter,"options":_vm.parameterList},on:{"input":_vm.update}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }